import { render } from "./items_details.vue?vue&type=template&id=4f70af74"
import script from "./items_details.vue?vue&type=script&lang=js"
export * from "./items_details.vue?vue&type=script&lang=js"

import "./items_details.vue?vue&type=style&index=0&id=4f70af74&lang=css"

import exportComponent from "D:\\vue\\alive-again\\sams-alive-again\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__